import React from 'react';

let idx = 0;
const uuid = () => (idx += 1); // eslint-disable-line no-return-assign

/* eslint-disable react/prop-types */
const withId = Wrapped => {
  const WithId = props => {
    const { id, ...rest } = props;
    const uniqueId = id || `id-${uuid()}`;
    return <Wrapped {...rest} id={uniqueId} />;
  };

  WithId.displayName = `${Wrapped.displayName || Wrapped.name}`;
  return WithId;
};

export default withId;



// WEBPACK FOOTER //
// ./src/utils/withId.js